import { render } from "./SignBlue.vue?vue&type=template&id=f2bfe7ea&scoped=true"
const script = {}

import "./SignBlue.vue?vue&type=style&index=0&id=f2bfe7ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f2bfe7ea"

export default script